// General imports, like internal and external libraries
import Loading from 'atoms/Loading'
import { Suspense, useEffect, useState } from 'react'
import { Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router'

import './index.css'

// Containers (Every page of our module)
import RoutesList from './containers/RouteList'
import RoutesDetail from './containers/RouteDetail'
import { readRouteDetails } from 'services/kraken-core/routes/routes.service'
import isEmpty from 'lodash.isempty'
import { Layout, LoadingDots, Tag, Text } from '@loadsmart/loadsmart-ui'

const RouteDetailFromCode = () => {
  const history = useHistory()
  const { code } = useParams<{ code: string }>()
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    if (isEmpty(code)) {
      setLoading(false)
      return
    }

    readRouteDetails(code).then(([error, response]) => {
      setLoading(false)
      if (response?.data?.id) {
        history.push(`/routes/${response.data.id}`)
      } else {
        setNotFound(true)
      }
    })
  }, [code, history])

  if (notFound) {
    return (
      <Layout.Group>
        <Text>No route found for code &quot;{code}&quot;</Text>
      </Layout.Group>
    )
  }

  if (loading) {
    return (
      <Layout.Group>
        <Text>
          Forwarding to <Tag variant="accent">{code}</Tag>
        </Text>
        <LoadingDots />
      </Layout.Group>
    )
  }

  return null
}

const TradingPartnerIndex = () => {
  const { path } = useRouteMatch()

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path={path}>
          <RoutesList />
        </Route>
        <Route path={`${path}/:id`} exact>
          <RoutesDetail />
        </Route>
        <Route path={`${path}/code/:code`} exact>
          <RouteDetailFromCode />
        </Route>
      </Switch>
    </Suspense>
  )
}

export default TradingPartnerIndex
